import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamDialog, PersonDialog, VolunteerDialog } from '../../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccMentor } from '../acc-mentors-view.part';

export function getActions(dialogService: DialogService, areaService: AcceleratorAreaService): GridAction<AccMentor>[] {

	const actions: GridAction<AccMentor>[] = [
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'View Team Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(AccTeamDialog, { data: { accTeamId: rows[0]!.accTeamId } }, 900, 900);
				await areaService.reloadData(); // TODO: optimize to avoid full reload if no changes
			}
		},
		{
			iconClass: 'fa-regular fa-user-tie',
			label: 'View Volunteer Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(VolunteerDialog, { data: { volunteerId: rows[0]!.volunteerId } }, 900, 900);
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
	];

	return actions;
}